
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M6.545 8.163a.75.75 0 01-.487-1.044l1.66-3.535a.75.75 0 011.36.002l.732 1.569.08-.027a8.15 8.15 0 11-5.8 5.903.75.75 0 111.456.364 6.65 6.65 0 104.907-4.862l.74 1.583a.75.75 0 01-.872 1.043z"}})])
          )
        }
      }
    